/** @flow */
import type { State } from "@store/reducers";
import type { PropertiesSchema } from "@types";
import type { FocusListsType } from "@modules/reporting/reducer/focus-lists/types";
import type {
  DepartmentReport,
  Reports,
  DefaultReports,
} from "@modules/reporting/reducer/focus-lists/department/types";

export type GetReportsSchema = (state: State) => ?PropertiesSchema;
export type GetReportToSave = (state: State) => ?DepartmentReport;

export const getDepartmentFocusLists = (
  state: State,
): $PropertyType<FocusListsType, "department"> => state.reporting.focusLists.department;

export const getReports = (state: State): Reports => getDepartmentFocusLists(state).reports;

export const getDefaultReports = (state: State): DefaultReports =>
  getReports(state).defaultReports || [];

export const getMyReports = (state: State): DefaultReports => getReports(state).myReports || [];

export const getReportsSchema = (state: State): ?PropertiesSchema => getReports(state).schema;

export const getReportToSave = (state: State): ?DepartmentReport => getReports(state).reportToSave;

export const isLoading = (state: State): boolean =>
  state.reporting.focusLists.department.reports.requestsInProgress > 0;
